import Client from '@/app/repository/axios-client';

const resource = '/account/guardians';

export default {
  createGuardian(payload) {
    return Client.post(`${resource}`, payload);
  },
  update(accountId, payload) {
    return Client.put(`${resource}/${accountId}`, payload);
  },
  updateAddress(accountId, payload) {
    return Client.put(`${resource}/${accountId}/address`, payload);
  },
  getAccount(accountId) {
    return Client.get(`${resource}/${accountId}`);
  },
  getGuardiansForGrid(parameters) {
    return Client.get(`${resource}` + parameters);
  },
  activateGuardian(accountId, payload) {
    return Client.patch(`${resource}/${accountId}/activate`, payload);
  },
  deactivateGuardian(accountId, payload) {
    return Client.patch(`${resource}/${accountId}/deactivate`, payload);
  },
  checkGuardianEmailExist(payload) {
    return Client.put(`${resource}/email-check`, payload);
  },
  findGuardiansByAccountIds(payload) {
    return Client.post(`${resource}/by-ids`, payload);
  },
  findGuardiansBySubaccountId(subaccountId) {
    return Client.get(`${resource}/subaccount/${subaccountId}`);
  },
  enableGuardianForSubaccount(guardianId, subaccountId) {
    return Client.put(`${resource}/${guardianId}/subaccount/${subaccountId}/enable`);
  },
  disableGuardianForSubaccount(guardianId, subaccountId) {
    return Client.put(`${resource}/${guardianId}/subaccount/${subaccountId}/disable`);
  }
};
